import moment from 'moment'

export default defineNuxtPlugin({
  name: 'moment',
  setup(nuxtApp) {
    return {
      provide: {
        moment,
      },
    }
  },
})
